import { Badge, styled } from "@mui/material";

const StyledBadge = styled(Badge)({
  "& .MuiBadge-badge": {
    padding: "1rem",
    borderRadius: "50%",
    lineHeight: "1rem",
    aspectRatio: "1",
  },
});
export default StyledBadge;
